import useUpgradesStore from "@/store/useUpgradesStore";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

class MountainBellowsBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MOUNTAIN_BELLOWS;

	public get requirements(): Map<ResourceType, number> {
		const requirements = new Map<ResourceType, number>(super.requirements);

		// Apply upgrades
		let connectionRequirement =
			(requirements.get(ResourceType.SETTLEMENT_CONNECTION) as number) ||
			0;
		if (
			useUpgradesStore().getCurrentLevelById(UpgradeIds.mountain_paths) >
			0
		) {
			connectionRequirement = 0;
		}
		requirements.set(
			ResourceType.SETTLEMENT_CONNECTION,
			connectionRequirement,
		);

		return requirements;
	}
}

export default MountainBellowsBuildingTileEntity;
